'use client';

export { CaseDetailsScreen } from './CaseDetailsScreen';
